import { Button, type SxProps } from "@biom3/react";
import NextLink from "next/link";
import type { ComponentProps } from "react";

type PlayButtonProps = {
  playLink: string;
  buttonSize?: ComponentProps<typeof Button>["size"];
  analyticsEvent?: (link: string) => void;
  text?: string;
  sx?: SxProps;
};
export function PlayButton({
  playLink,
  analyticsEvent,
  buttonSize = "medium",
  text = "Play",
  sx,
}: PlayButtonProps) {
  return (
    <Button
      variant="tertiary"
      size={buttonSize}
      sx={{ ...sx }}
      rc={
        <NextLink
          target="_blank"
          href={playLink}
          onClick={() => analyticsEvent?.(playLink)}
        />
      }
    >
      <Button.Icon icon="ESports" iconVariant="bold" />
      {text}
    </Button>
  );
}
